import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, throwError, of } from 'rxjs';
import { environment } from '../../../environments/environment';
const endpoint = environment.api_endpoint;
@Injectable({
  providedIn: 'root',
})
export class WorkflowService {
  constructor(private http: HttpClient) {}

  checkOnboardingStatus(): Observable<any> {
    const apiUrl = `${endpoint}/api/v1/gateway/onboarding/verify`;
    const accessToken = localStorage.getItem('accessToken');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    });
    return this.http.get<any>(apiUrl, { headers });
  }

  /** Function to load workflow with workflowID */
  loadWorkflow(
    wId: string,
    recordId?: string,
  ): Observable<{ workflowData: any; recordId?: string }> {
    const apiUrl = `${endpoint}/api/v1/workflow/instances/${wId}`;

    const accessToken = localStorage.getItem('accessToken');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
      // 'X-Product-frontend': 'cc_frontend',
    });

    return this.http.get<any>(apiUrl, { headers }).pipe(
      map((data: any) => ({
        workflowData: data.data,
        recordId,
      })),
      catchError((err) => {
        return throwError(() => err);
      }),
    );
  }

  updateWorkflowInstance(apiUrl: string, data: any): Observable<any> {
    const accessToken = localStorage.getItem('accessToken');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
      // 'X-Product-frontend': 'cc_frontend',
    });
    return this.http.put<any>(endpoint + apiUrl, data, {
      headers,
      observe: 'response' as const,
    });
  }

  updateStepperState(workflowData: any, nodeId: string): void {
    const stepperItems =
      workflowData?.layout?.leftColumnProperties?.stepperData?.stepperItems;
    const nodes = workflowData?.nodes;
    if (!stepperItems || !nodes) return;

    const currentNode = nodes.find((n: any) => n._id === nodeId);
    if (!currentNode) return;

    const { stepperParentId, stepperChildId } = currentNode;

    for (let i = 0; i < stepperItems.length; i++) {
      const parent = stepperItems[i];

      // For Parent with children
      if (parent.id === stepperParentId && Array.isArray(parent.children)) {
        const childIndex = parent.children.findIndex(
          (child: any) => child.id === stepperChildId,
        );
        if (childIndex !== -1) {
          parent.children[childIndex].completed = true;
          parent.children[childIndex].active = false;

          if (childIndex < parent.children.length - 1) {
            parent.children[childIndex + 1].active = true;
          } else {
            parent.completed = true;
            parent.active = false;
            const nextParent = stepperItems[i + 1];
            if (nextParent) {
              nextParent.active = true;
              if (
                Array.isArray(nextParent.children) &&
                nextParent.children.length > 0
              ) {
                nextParent.children[0].active = true;
              }
            }
          }
          return;
        }
      }

      // For parent without children
      if (
        parent.id === stepperParentId &&
        (!parent.children || parent.children.length === 0)
      ) {
        parent.completed = true;
        parent.active = false;

        const nextParent = stepperItems[i + 1];
        if (nextParent) {
          nextParent.active = true;
          if (
            Array.isArray(nextParent.children) &&
            nextParent.children.length > 0
          ) {
            nextParent.children[0].active = true;
          }
        }
        return;
      }
    }
  }

  resetWorkflowInstance(id: string): Observable<any> {
    const apiUrl = `${endpoint}/api/v1/workflow/instances/reset/${id}`;
    const accessToken = localStorage.getItem('accessToken');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    });
    return this.http.get<any>(apiUrl, { headers });
  }
}
